import { useTranslation } from "react-i18next";
import { useState, useEffect } from "react";
import Reviews from "./Reviews";
import LogoLoop from "./LogoLoop";
import Engel from "../../Assets/Clients/engel-volkers.webp";
import EngelMobile from "../../Assets/Clients/mobile/engel-volkers.webp";
import CircuitMallorca from "../../Assets/Clients/circuitmallorca.webp";
import CircuitMallorcaMobile from "../../Assets/Clients/mobile/circuitmallorca.webp";
import Mediaset from "../../Assets/Clients/mediaset.webp";
import MediasetMobile from "../../Assets/Clients/mobile/mediaset.webp";
import Dazn from "../../Assets/Clients/dazn.webp";
import DaznMobile from "../../Assets/Clients/mobile/dazn.webp";
import Movistar from "../../Assets/Clients/movistar.webp";
import MovistarMobile from "../../Assets/Clients/mobile/movistar.webp";
import Ib3 from "../../Assets/Clients/ib3.webp";
import Ib3Mobile from "../../Assets/Clients/mobile/ib3.webp";
import RTVE from "../../Assets/Clients/rtve.webp";
import RTVEMobile from "../../Assets/Clients/mobile/rtve.webp";
import Mariahibbs from "../../Assets/Clients/mariahibbs.webp";
import MariahibbsMobile from "../../Assets/Clients/mobile/mariahibbs.webp";
import JosefinWestin from "../../Assets/Clients/JosefinWestin.webp";
import JosefinWestinMobile from "../../Assets/Clients/mobile/JosefinWestin.webp";
import Milanobeach from "../../Assets/Clients/milanobeach.webp";
import MilanobeachMobile from "../../Assets/Clients/mobile/milanobeach.webp";
import Lunasgrill from "../../Assets/Clients/lunasgrill.webp";
import LunasgrillMobile from "../../Assets/Clients/mobile/lunasgrill.webp";
import Turo from "../../Assets/Clients/turo.webp";
import TuroMobile from "../../Assets/Clients/mobile/turo.webp";
import LCI from "../../Assets/Clients/lci.webp";
import LCIMobile from "../../Assets/Clients/mobile/lci.webp";
import R312 from "../../Assets/Clients/312.webp";
import R312Mobile from "../../Assets/Clients/mobile/312.webp";

const Testimonials = () => {
   const { t } = useTranslation();
   const [isMobile, setIsMobile] = useState(false);

   // Detectar si es móvil al cargar y al redimensionar
   useEffect(() => {
      const checkMobile = () => setIsMobile(window.innerWidth <= 768);
      checkMobile();
      window.addEventListener("resize", checkMobile);
      return () => window.removeEventListener("resize", checkMobile);
   }, []);
   
   const imageLogos = [
      {
         src: isMobile ? EngelMobile : Engel,
         alt: "Engel & Völkers",
      },
      {
         src: isMobile ? CircuitMallorcaMobile : CircuitMallorca,
         alt: "CircuitMallorca",
      },
      {
         src: isMobile ? MediasetMobile : Mediaset,
         alt: "Mediaset",
      },
      {
         src: isMobile ? LCIMobile : LCI,
         alt: "LCI",
      },
      {
         src: isMobile ? MariahibbsMobile : Mariahibbs,
         alt: "Maria Hibbs",
      },
      {
         src: isMobile ? R312Mobile : R312,
         alt: "312",
      },
      {
         src: isMobile ? JosefinWestinMobile : JosefinWestin,
         alt: "Josefin Westin",
      },
      {
         src: isMobile ? RTVEMobile : RTVE,
         alt: "RTVE",
      },
      {
         src: isMobile ? MilanobeachMobile : Milanobeach,
         alt: "Milano Beach",
      },
      {
         src: isMobile ? DaznMobile : Dazn,
         alt: "Dazn",
      },
      {
         src: isMobile ? LunasgrillMobile : Lunasgrill,
         alt: "Lunas Grill",
      },
      {
         src: isMobile ? Ib3Mobile : Ib3,
         alt: "IB3",
      },
      {
         src: isMobile ? MovistarMobile : Movistar,
         alt: "Movistar",
      },
      {
         src: isMobile ? TuroMobile : Turo,
         alt: "Turo",
      },
   ];

   return (
      <div
         className="testimonials-container"
         data-aos="fade-in"
         data-aos-duration="2000"
      >
         <h2>{t("trusted_clients")}</h2>
         <div className="testimonials">
            <div
               style={{
                  height: "auto",
                  position: "relative",
                  overflow: "hidden",
               }}
            >
               <LogoLoop
                  logos={imageLogos}
                  speed={30}
                  direction="right"
                  logoHeight={100}
                  gap={20}
                  hoverSpeed={0}
                  scaleOnHover
                  fadeOut
                  fadeOutColor="var(--bg-dark)"
                  ariaLabel="Technology partners"
               />
            </div>
         </div>

         <h2>{t("testimonials")}</h2>
         <div className="testimonials">
            <Reviews />
         </div>
      </div>
   );
};

export default Testimonials;